import { searchParamsToObject } from '@packages/shared/src/utils/searchParamsToObject/searchParamsToObject';
import { unmask } from '@packages/gql/src/betterMasking';
import type { FragmentType } from '@packages/gql/generated/shopping/fragment-masking';
import type { UseDisplayModeFragmentFragmentDoc } from '@packages/gql/generated/shopping/UseDisplayModeFragmentFragmentDoc';
import { type ProductListDisplayMode } from '@packages/gql/generated/shopping/graphql';

import { decodeDisplayMode } from '../queryEncoding';

/* GraphQL */ `
  fragment UseDisplayModeFragment on SearchProductResult {
    defaultDisplayMode
  }
`;

const getInternalDisplayMode = (apiDisplayMode: ProductListDisplayMode) => {
  switch (apiDisplayMode) {
    case 'LARGE_CARDS':
      return 'largeCards';
    case 'MORE_INFORMATION':
      return 'moreInformation';
    case 'CARDS':
    default:
      return 'cards';
  }
};

export const getDeviceIndependentDisplayMode = (
  maskedResult: FragmentType<typeof UseDisplayModeFragmentFragmentDoc>,
  searchParams: URLSearchParams | null,
) => {
  const data = unmask<typeof UseDisplayModeFragmentFragmentDoc>(maskedResult);
  const defaultDisplayMode = getInternalDisplayMode(data.defaultDisplayMode);

  const searchParamsObject = searchParamsToObject(searchParams);
  const displayModeFromQuery = decodeDisplayMode(searchParamsObject);

  const displayMode = displayModeFromQuery ?? defaultDisplayMode;

  return {
    displayMode,
    defaultDisplayMode,
  };
};
